import { render } from "./ManagerIcon.vue?vue&type=template&id=0a177ea2"
import script from "./ManagerIcon.vue?vue&type=script&lang=js"
export * from "./ManagerIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__